<template>
  <div class="games-sorting" :class="{ 'games-sorting--active': isOpen }" v-click-outside="closeGameSort">
    <div class="games-sorting__container" @click="toggleGameSort">
      <div class="games-sorting__text">
        {{ activeOption.name }}
      </div>

      <atomic-icon id="arrow-sort" />
    </div>

    <list-single-active-option
      v-if="isOpen"
      :options="sortOptions"
      :activeOption="activeOption"
      @onSelectOption="onSelectOption"
    />
  </div>
</template>

<script setup lang="ts">
  import type { ISortOption } from '@skeleton/core/types';

  const props = defineProps<{
    sortBy?: string;
    sortOrder?: string;
    sortOptions: ISortOption[];
  }>();

  const { selectedOption } = await useSortingOptions();

  const route = useRoute();
  const router = useRouter();

  const isOpen = ref(false);

  const activeOption = ref<Record<string, any>>({});

  const updateQueryWithReplace = () => {
    router.replace({
      query: {
        ...route.query,
        sortBy: activeOption.value.sortBy,
        sortOrder: activeOption.value.sortOrder,
      },
    });
  };

  const onSelectOption = (item: Record<string, any>) => {
    activeOption.value = item;
    toggleGameSort();
    updateQueryWithReplace();
  };

  const toggleGameSort = () => {
    isOpen.value = !isOpen.value;
  };

  const closeGameSort = () => {
    isOpen.value = false;
  };

  watchEffect(() => {
    activeOption.value = selectedOption(props.sortBy, props.sortOrder);
  });
</script>

<style src="~/assets/styles/components/sorting/games-sorting.scss" lang="scss" />
